import { AddressInterface } from "interfaces/Address";
import { ContactInterface } from "interfaces/Contact";

// Required type coverage for reseller onboarding. A single address/contact can
// carry multiple types, so coverage is "at least one item of each required type".
export const REQUIRED_ADDRESS_TYPES = [
    { id: 1, name: "Primary" },
    { id: 2, name: "Billing" },
    { id: 3, name: "Shipping" },
];

// Contacts: Primary/Billing/Marketing/Purchasing/Sales are required; "Other" (6) is not.
export const REQUIRED_CONTACT_TYPES = [
    { id: 1, name: "Primary" },
    { id: 2, name: "Billing" },
    { id: 3, name: "Marketing" },
    { id: 4, name: "Purchasing" },
    { id: 5, name: "Sales" },
];

export interface CoverageResult {
    covered: number[];
    missing: { id: number; name: string }[];
    complete: boolean;
}

export const addressCoverage = (addresses?: AddressInterface[]): CoverageResult => {
    const present = new Set<number>();
    (addresses || []).forEach((a) => (a.addressTypes || []).forEach((t) => present.add(t.id)));
    const missing = REQUIRED_ADDRESS_TYPES.filter((t) => !present.has(t.id));
    return { covered: Array.from(present), missing, complete: missing.length === 0 };
};

export const contactCoverage = (contacts?: ContactInterface[]): CoverageResult => {
    const present = new Set<number>();
    (contacts || []).forEach((c) => (c.contactTypes || []).forEach((t) => present.add(t.id)));
    const missing = REQUIRED_CONTACT_TYPES.filter((t) => !present.has(t.id));
    return { covered: Array.from(present), missing, complete: missing.length === 0 };
};
